function initIsMyDeviceCompatibleTabs(scope = document) {
  const section = scope.querySelector('#is-my-device-compatible-section');
  if (!section || section.dataset.tabsInitialized === 'true') return;

  const tabTitles = section.querySelectorAll('.phone-type-tabs .product-tab-title');
  const tabDescriptions = section.querySelectorAll('.phone-types-description');
  if (!tabTitles.length || !tabDescriptions.length) return;

  const activateTab = (tab) => {
    const targetId = `${tab.id}-description`;
    const targetDescription = section.querySelector(`#${targetId}`);

    tabTitles.forEach((title) => {
      title.classList.remove('tab-active');
      title.setAttribute('aria-selected', 'false');
    });

    tabDescriptions.forEach((description) => {
      description.classList.remove('description-active');
      description.setAttribute('aria-selected', 'false');
    });

    tab.classList.add('tab-active');
    tab.setAttribute('aria-selected', 'true');

    if (targetDescription) {
      targetDescription.classList.add('description-active');
      targetDescription.setAttribute('aria-selected', 'true');
    }

    tab.parentElement?.scrollTo({
      left: tab.offsetLeft - 20,
      behavior: 'smooth',
    });
  };

  tabTitles.forEach((tab) => {
    tab.addEventListener('click', () => activateTab(tab));
    tab.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        activateTab(tab);
      }
    });
  });

  section.dataset.tabsInitialized = 'true';
}

document.addEventListener('DOMContentLoaded', () => {
  initIsMyDeviceCompatibleTabs(document);
});

document.addEventListener('shopify:section:load', (event) => {
  initIsMyDeviceCompatibleTabs(event.target);
});
